<template>
  <v-container
    id="product-list"
    fluid
    tag="section"
  >
    <div class="md-layout">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>

      <FilterForm 
        :filterForm="filterForm"
        @product-filter="search"
      />

      <div class="text-sm-right mb-3">
        <v-btn
            v-if="checkAuthorization('product_update')"
            v-show="(selected.length ? true : false)"
            color="blue"
            dark
            class="mb-2 mr-2"
            @click="changeEndDateMultipleItem"
        >
          Chọn thời gian sử dụng
        </v-btn>
        <v-btn
          v-if="checkAuthorization('product_delete')"
          v-show="(selected.length ? true : false)"
          color="default"
          dark
          class="mb-2 mr-2"
          @click="deleteMultipleItem"
        >
          Xóa tất cả
        </v-btn>
        <v-btn
          v-if="checkAuthorization('product_create')"
          color="primary"
          dark
          class="mb-2"
          @click="gotoNewPage"
        >
          <v-icon>mdi-plus</v-icon>Thêm Mới
        </v-btn>
      </div>

      <v-tabs
        class="mt-0 pl-3"
        @change="changeTab"
        v-model="tabIndex"
        color="primary"
        style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"
      >
        <v-tab :key="0">Tất Cả</v-tab>
        <v-tab v-for="(tab, i) in productStatusOptions" :key="i+1">{{ tab.text }}</v-tab>
      </v-tabs>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="tableData"
        :single-select="singleSelect"
        item-key="id"
        :show-select="checkAuthorization('product_delete')"
        class="table-layout pa-5"
        hide-default-footer
      >
        <template v-slot:top />

        <template v-slot:item.thumnail="{item}">
          <div>
            <v-img
              :src="getThumbnailUrl(item.images)"
              max-width="120"
            />
          </div>
        </template>

        <template v-slot:no-data>
          <common-no-result />
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom v-if="item.status === 'active'">
            <template v-slot:activator="{ on }">
              <v-icon size="20" @click="convertStatus(item.id, 'inactive')" color="info" icon v-on="on">mdi-block-helper</v-icon>
            </template>
            <span>Chuyển sang trạng thái ngừng hoạt động</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on }">
              <v-icon size="24" @click="convertStatus(item.id, 'active')" color="success" icon v-on="on">mdi-checkbox-marked-circle</v-icon>
            </template>
            <span>Chuyển sang trạng thái hoạt động</span>
          </v-tooltip>

          <v-tooltip bottom v-if="checkAuthorization('product_update')">
            <template v-slot:activator="{ on }">
              <v-btn class="mr-2 ml-2" @click="editItem(item)" icon small color="primary"  v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
            <span>Cập nhật thông tin sản phẩm</span>
          </v-tooltip>
          <v-tooltip bottom v-if="checkAuthorization('product_delete')">
            <template v-slot:activator="{ on }">
              <v-btn @click="deleteItem(item)" icon small color="default"  v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
            <span>Xóa sản phẩm</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <!-- Pagination -->
      <v-row>
        <v-col
          cols="12"
          sm="6"
        />
        <v-col
          cols="12"
          sm="6"
        >
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            :length="getTotalItem(totalItem, limit)"
            class="justify-sm-end"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </div>
    <modal-form-end-date :selected="selected" :listTypeEndDate="listTypeEndDate"/>
  </v-container>
</template>

<script>
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import FilterForm from './components/FilterForm'
  import { productStatusOptions } from '../../../helpers/constants'
  import {formatDate, formatPrice} from '../../../helpers/utils'
  import ModalFormEndDate from "@/pages/products/product/components/ModalFormEndDate";
  const ProductRepository = RepositoryFactory.get('product')
  const ProductGroupRepository = RepositoryFactory.get('product_group')

  export default {
    components: {ModalFormEndDate, FilterForm},
    data () {
      return {
        singleSelect: false,
        selected: [],
        tableData: [],
        headers: [
          {
            text: 'Mã sản phẩm',
            align: 'center',
            sortable: false,
            value: 'code',
          },
          { text: 'Tên sản phẩm', value: 'name', align: 'center', },
          { text: 'Giá bán lẻ', value: 'price', align: 'center', },
          { text: 'Đơn vị', value: 'unit', align: 'center', },
          { text: 'Hình ảnh', value: 'thumnail', align: 'center', },
          { text: 'Nhóm sản phẩm', value: 'group.name', align: 'center', },
          { text: 'Trạng thái', value: 'statusText', align: 'center', },
          { text: 'Ngày hết hạn', value: 'endDateText', align: 'center', }
        ],
        errorMessage: '',
        loading: false,
        filterForm: {},
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        productStatusOptions,
        groupIds: [],
        tabIndex: 0,
        listTypeEndDate: [
          {
            type: 'day',
            title: 'Chọn ngày'
          },
          {
            type: 'month',
            title: 'Chọn tháng'
          }
        ]
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.fetchTableData()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.fetchTableData()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    mounted () {
      this.fetchTableData()
    },
    created() {
      Bus.$on('product-list-reload', () => {
        this.fetchTableData()
      })
      if ( this.checkAuthorization('product_update') || this.checkAuthorization('product_create')) {
        this.headers.push({ text: 'Thao tác', value: 'action', align: 'center', sortable: false });
      }
    },
    methods: {
      changeTab() {
        if (this.tabIndex === 0) {
          this.filterForm.status = '';
        } else if (this.tabIndex === 1) {
          this.filterForm.status = 'draft';
        } else if (this.tabIndex === 2) {
          this.filterForm.status = 'active';
        } else if (this.tabIndex === 3) {
          this.filterForm.status = 'inactive';
        }
        this.currentPage = 1;
        this.fetchTableData();
      },
      search (filterForm) {
        if(filterForm) {
          this.filterForm = filterForm
        }
        this.fetchTableData()
      },

      async convertStatus (id, status) {
        const statusProduct = {
          status,
        }
        this.$swal({
          title: 'Chuyển đổi trạng thái',
          text: 'Bạn có thực sự chắc chắn ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const response = await ProductRepository.updateStatus(id, statusProduct)
            if (response.success) {
              this.$swal({
                  title: 'Chuyển đổi thành công !',
                  confirmButtonText: 'Đồng ý',
                },
              ).then(() => {
                // window.location.reload()
                Bus.$emit('product-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },

      setAlertMessage (alert, type, text) {
        this.alert = alert
        this.alertMessageText = text
        this.alertMessageType = type
      },

      getThumbnailUrl (images) {
        if (_.isArray(images) && images.length) {
          let isThumbnail
          let url = ''
          _.forEach(images, function (image) {
            isThumbnail = _.get(image, 'ImageItem.isThumbnail', false)
            if (isThumbnail) {
              url = _.get(image, 'filePath', '')
            }
          })
          return url
        }
        return ''
      },

      gotoNewPage () {
        this.$router.push({
          name: 'CreateProduct',
        })
      },

      editItem (item) {
        this.$router.push({
          name: 'EditProduct',
          params: {
            id: _.get(item, 'id', 0),
          },
        })
      },
      
      async deleteItem (item) {
        this.$swal({
          title: 'Xóa sản phẩm',
          text: 'Bạn có thực sự muốn xoá sản phẩm này?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const response = await ProductRepository.deleteOneItem(_.get(item, 'id', 0))
            // loader.hide()
            this.appLoadingData(false)
            if (response.success) {
              this.$swal({
                title: 'Xoá thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('product-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },

      async deleteMultipleItem () {
        this.$swal({
          title: 'Xóa toàn bộ sản phẩm',
          text: 'Bạn có thực sự muốn xoá các sản phẩm này?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const response = await ProductRepository.deleteManyItems(this.selected.map(s => s.id))
            // loader.hide()
            this.appLoadingData(false)
            if (response.success) {
              this.selected = []
              this.$swal({
                title: 'Xoá thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('product-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },

      async fetchTableData () {
        // this.loading = this.$loading.show()
        this.appLoadingData(true)
        const response = await ProductRepository.list({
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          status: this.filterForm.status,
          groupId: this.filterForm.groupId,
          siteIds: this.filterForm.siteId
        })
        if (response.success) {
          this.errorMessage = ''
          this.tableData = _.get(response, 'data').map(data => {
            return {
              ...data,
              statusText: _.get(productStatusOptions.find(s => s.value === data.status), 'text', ''),
              price: formatPrice(data.price),
              endDateText: data.endMonth || data.endDate ? data.endMonth ? `Sau ${data.endMonth} tháng` : `Ngày ${formatDate(data.endDate)}` : ''
            }
          })
          this.totalItem = parseInt(_.get(response, 'totalItem', 0), 10)
        } else {
          this.errorMessage = _.get(response, 'message', '')
        }
        // this.loading.hide()
        this.appLoadingData(false)
      },
      changeEndDateMultipleItem() {
        Bus.$emit("open-form-end-date")
        this.openFormEndDate = true;
      }
    },
  }
</script>
